import {
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  FormLabel,
  TextField,
  FormGroup,
  Switch,
  Checkbox,
  Box,
  Button,
} from "@mui/material";
import {
  InputDiv,
  SummaryDiv,
  RadioDiv,
  InputRow,
  StyledBox,
  InputDivFull,
} from "../styles";
import SaveImg from "../../../../assets/styled-icons/Save.png";
import { BsCaretDown, BsCaretUp } from "react-icons/bs";
import {
  ChangeEvent,
  SyntheticEvent,
  useContext,
  useEffect,
  useState,
} from "react";
import {
  AccomodationFieldType,
  ResponsibleAgencyEnum,
  ResponsibleContactEnum,
  RsvpType,
} from "../../../../types/rsvp/index";

import { FormProvider, useForm } from "react-hook-form";
import { useRsvp } from "../../../../contexts/rsvp.context";
import { Input } from "../../../Input";
import { FormInputMultiCheckbox } from "../PreCongress/FormMultipleCheckBox";
import ColorToggleButton from "../../../ToggleButtonGroup";
import { LabeledAutoComplete } from "../../../UI/LabeledAutoComplete";
import { removeDuplicatesByLabel } from "../utils";
import GenericServiceType from "../../GenericServiceType";
import { ACCOMMODATIONS } from "../../../../utils/serviceTypesFromBudget";

type Props = {
  onSubmitNav: () => void;
  isDisabled: boolean;
};

export function Accomodation({ onSubmitNav, isDisabled }: Props) {
  const { rsvpId, updateAccomodation, createRsvp, accomodation } = useRsvp();

  const agencyOptions = (
    Object.keys(ResponsibleAgencyEnum) as Array<
      keyof typeof ResponsibleAgencyEnum
    >
  ).map((el) => {
    return { label: ResponsibleAgencyEnum[el], value: el };
  });

  const responsibleContactOptions = (
    Object.keys(ResponsibleContactEnum) as Array<
      keyof typeof ResponsibleContactEnum
    >
  ).map((el) => {
    return { label: ResponsibleContactEnum[el], value: el };
  });
  const [responsibleAgencyState, setResponsibleAgencyState] = useState(
    [] as string[]
  );
  const [responsibleContactState, setResponsibleContactState] = useState(
    [] as string[]
  );

  const obj: AccomodationFieldType = {
    accomodationManagement: "",
    responsibleContact: [],
    accomodationUpgrades: "",
    upgradeValues: {
      aptSingle: {
        description: "",
        valueType: "",
        obs: "",
      },
      aptDouble: {
        description: "",
        valueType: "",
        obs: "",
      },
      aptTriple: {
        description: "",
        valueType: "",
        obs: "",
      },
      proDouble: {
        description: "",
        valueType: "",
        obs: "",
      },
      singleTriple: {
        description: "",
        valueType: "",
        obs: "",
      },
      extraBed: {
        description: "",
        valueType: "",
        obs: "",
      },
      cradle: {
        description: "",
        valueType: "",
        obs: "",
      },
      policyForChildren: {
        description: "",
        valueType: "",
        obs: "",
      },
      test: "hey",
    },
    accomodationManagementObs: "",
    responsibleAgency: [],
    contactToggle: false,
    hotelToggle: false,
  };
  const methods = useForm({
    defaultValues: obj,
  });
  const { handleSubmit, register, watch, setValue, reset, control } = methods;
  const [contactSearch, setContactSearch] = useState("");
  const [contactSelected, setContactSelected] = useState<any[]>([]);

  function onSubmit(form: AccomodationFieldType) {
    let responsibleAgency = [];
    if (watch("contactToggle")) {
      responsibleAgency.push("OFFICIAL_AGENCY");
    }
    if (watch("hotelToggle")) {
      responsibleAgency.push("HOTEL");
    }

    const dataForm = {
      ...form,
      responsibleAgency,
      responsibleContact: contactSelected.map((i) => i?.value),
    };

    rsvpId
      ? updateAccomodation(dataForm)
      : createRsvp({ accomodation: dataForm } as RsvpType);
    onSubmitNav();
  }

  const valueFields = (
    Object.keys(obj.upgradeValues) as Array<keyof typeof obj.upgradeValues>
  ).map((el) => {
    return (
      <InputRow key={el}>
        <Input
          key={`upgradeValues.${el}.description`}
          {...register(`upgradeValues.${el}.description`)}
          label="Diária extra em apt single"
        />
        <Input
          key={`upgradeValues.${el}.valueType`}
          {...register(`upgradeValues.${el}.valueType`)}
          label="Tipo de pensão"
        />
        <Input
          key={`upgradeValues.${el}.obs`}
          {...register(`upgradeValues.${el}.obs`)}
          label="Obs"
        />
      </InputRow>
    );
  });

  useEffect(() => {
    if (accomodation) {
      setResponsibleAgencyState(accomodation.responsibleAgency);
      setResponsibleContactState(accomodation.responsibleContact);
      reset(accomodation);
      const selectedContacts = responsibleContactOptions.filter((option: any) =>
        accomodation.responsibleContact?.some(
          (item: any) => item === option?.value
        )
      );
      setContactSelected(selectedContacts);
    }
  }, [accomodation]);

  const handleChangeContact = (
    event: SyntheticEvent<Element, Event>,
    newValue: any
  ) => {
    if (newValue?.some((i: any) => i?.value === "ALL")) {
      setContactSelected(responsibleContactOptions);
      setContactSearch("");
      return;
    }

    const newValues: any[] = removeDuplicatesByLabel(newValue);
    setContactSelected(newValues);
    setContactSearch("");
  };

  return (
    <FormProvider {...methods}>
      <StyledBox onSubmit={handleSubmit(onSubmit)} style={{ marginLeft: 16 }}>
        <h3>3.Hospedagem</h3>
        <InputDivFull>
          <SummaryDiv>
            <strong>Antecipar ou estender hospedagem</strong>
            <span style={{ color: "#A1A1A1" }}>
              Como será o deslocamento. Caso tenha reembolso confirmar em RSVP e
              alinhar com convidado
            </span>
          </SummaryDiv>
          <RadioDiv>
            <FormControl>
              <RadioGroup
                value={watch("accomodationManagement")}
                onChange={(e) =>
                  setValue("accomodationManagement", e.target.value)
                }
              >
                <FormControlLabel
                  value="REQUESTS_DIRECTL_WITHOUT_REFUND"
                  control={<Radio />}
                  label="Gerencia por conta (PAX solicita diretamente com o hotel, sem reembolso)"
                />
                <FormControlLabel
                  value="SHIPPING_TO_MM_TRAVEL"
                  control={<Radio />}
                  label="Envio para a MM Travel via departamento corporativo. Informações coletadas pelo consultor RSVP (Nome completo e idade de crianças)"
                />
                <FormControlLabel
                  value="VALIDATE_WITH_CLIENT"
                  control={<Radio />}
                  label="Validar com o cliente"
                />
              </RadioGroup>
            </FormControl>
            <Input
              {...register("accomodationManagementObs")}
              label="Outro"
              placeholder="Especifique"
              multiline
              size="small"
            />
          </RadioDiv>
        </InputDivFull>
        <InputDivFull>
          <SummaryDiv style={{ marginTop: 8 }}>
            <strong>Contatos de responsável</strong>
            <span style={{ color: "#A1A1A1" }}>
              Informar tipo de contato e dados necessários
            </span>
          </SummaryDiv>
          <RadioDiv>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                <span>Contato</span>
                <ColorToggleButton
                  name="contactToggle"
                  options={[
                    { label: "Sim", value: true },
                    { label: "Não", value: false },
                  ]}
                  control={control}
                />
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                <span>Hotel</span>
                <ColorToggleButton
                  name="hotelToggle"
                  options={[
                    { label: "Sim", value: true },
                    { label: "Não", value: false },
                  ]}
                  control={control}
                />
              </div>
            </div>
            {/* <FormGroup>
              <FormLabel>Contato</FormLabel>
              <FormInputMultiCheckbox
                name={"responsibleAgency"}
                control={control}
                label={"label"}
                options={agencyOptions}
                setValue={setValue}
                previousSelected={responsibleAgencyState}
                setControlledState={setResponsibleAgencyState}
                optionSelectAll={false}
              />
            </FormGroup> */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: 16,
              }}
            >
              <span>Dados do responsável</span>
              <LabeledAutoComplete
                multiple
                options={[
                  { label: "Todas", value: "ALL" },
                  ...responsibleContactOptions,
                ]}
                inputValue={contactSearch}
                value={contactSelected}
                disablePortal
                getOptionLabel={(option) => option.label || ""}
                size="small"
                label=""
                renderInput={(params) => {
                  return (
                    <TextField
                      {...params}
                      onChange={(
                        e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
                      ) => {
                        setContactSearch(e.target.value);
                      }}
                    />
                  );
                }}
                onChange={handleChangeContact}
              />
            </div>
            {/* <FormGroup>
              <FormLabel>Dados do Responsável</FormLabel>
              <FormInputMultiCheckbox
                name={"responsibleContact"}
                control={control}
                label={"label"}
                options={responsibleContactOptions}
                setValue={setValue}
                previousSelected={responsibleContactState}
                setControlledState={setResponsibleContactState}
                optionSelectAll={true}
              />
            </FormGroup> */}
          </RadioDiv>
        </InputDivFull>
        <InputDivFull>
          <SummaryDiv>
            <strong>Upgrades em valores na hospedagem</strong>
            <span>
              Procedimentos informados em 8.Outros detalhados para confirmação
              no RSVP
            </span>
          </SummaryDiv>
          <RadioDiv>
            {/* <GenericServiceType
              serviceOptions={ACCOMMODATIONS}
              onSelectServiceType={() => null}
              previousSelectedServiceType=""
            /> */}
            <FormControl>
              <RadioGroup
                value={watch("accomodationUpgrades")}
                onChange={(e) =>
                  setValue("accomodationUpgrades", e.target.value)
                }
              >
                <FormControlLabel
                  value="NO_ACCESS_UNTIL_CHECK_IN"
                  control={<Radio />}
                  label="Não, o convidado só terá acesso aos valores no momento do check-in"
                />
                <FormControlLabel
                  value="INFORM_COSTS_ACCORDING_TO_TABLE_BELOW"
                  control={<Radio />}
                  label="Sim, informar os custos ao convidado conforme tabela abaixo"
                />
              </RadioGroup>
            </FormControl>
          </RadioDiv>
        </InputDivFull>
        <InputDivFull>
          {watch("accomodationUpgrades") ===
          "INFORM_COSTS_ACCORDING_TO_TABLE_BELOW" ? (
            <>
              <SummaryDiv>
                <strong>Valores</strong>
              </SummaryDiv>
              <RadioDiv>{valueFields}</RadioDiv>
            </>
          ) : (
            <RadioDiv>
              <span>
                A tabela será mostrada ao selecionar o informe de custos
              </span>
            </RadioDiv>
          )}
        </InputDivFull>

        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "flex-end",
            marginTop: 16,
          }}
        >
          <Button variant="contained" type="submit" disabled={isDisabled}>
            Salvar e avançar
          </Button>
        </div>
      </StyledBox>
    </FormProvider>
  );
}
